import dayjs from "dayjs";

const matchForecast = (item, weekEnd) =>
    item.forecastAmounts?.find(fa => dayjs(fa.weekEndDate).endOf("week").isSame(weekEnd, "day"));

export const buildForecastExportColumns = (weekEndDates, { includeEndInMarketDate = false } = {}) => {
    const columns = [
        { header: "Product", key: "productName", width: 40 },
        { header: "Distributor", key: "distributorSapId", width: 12 },
        { header: "BBC SKU", key: "sku", width: 12 },
        { header: "Customer Part Number", key: "customerPartNumber", width: 18 },
        { header: "Fulfillment Method", key: "fulfillmentMethod", width: 20 },
        { header: "In-Market Date", key: "inMarketDate", width: 14 },
    ];

    if (includeEndInMarketDate) {
        columns.push({ header: "End In-Market Date", key: "endInMarketDate", width: 14 });
    }

    weekEndDates.forEach((weekEnd, i) => {
        const label = weekEnd.format("MM/DD/YY");
        columns.push({ header: `${label} F`, key: `week${i}F`, width: 10 });
        columns.push({ header: `${label} A`, key: `week${i}A`, width: 10 });
    });

    return columns;
};

export const buildForecastExportRow = (item, weekEndDates, fulfillmentMethodById, { includeEndInMarketDate = false } = {}) => {
    const row = {
        productName: item.product?.name ?? "",
        distributorSapId: item.distributorSapId ?? "",
        sku: item.product?.sku ?? "",
        customerPartNumber: item.customerPartNumber ?? "",
        fulfillmentMethod: fulfillmentMethodById.get(item.fulfillmentMethodId) ?? "",
        inMarketDate: item.inMarketDate ? dayjs(item.inMarketDate).format("MM/DD/YY") : "",
    };

    if (includeEndInMarketDate) {
        row.endInMarketDate = item.endInMarketDate ? dayjs(item.endInMarketDate).format("MM/DD/YY") : "";
    }

    weekEndDates.forEach((weekEnd, i) => {
        const found = matchForecast(item, weekEnd);
        row[`week${i}F`] = (!found || found.originalAmount == null || isNaN(found.originalAmount)) ? "" : Math.round(found.originalAmount);
        row[`week${i}A`] = (!found || found.forecastAdjustmentId === 0 || found.adjustedAmount == null || isNaN(found.adjustedAmount)) ? "" : Math.round(found.adjustedAmount);
    });

    return row;
};
